<ng-container [formGroup]="form()">
  <div class="consents">
    @for (consent of consentsConfig(); track consent) {
      @if (!isCountryConsent(consent)) {
        <span
          [innerHTML]="consent?.text | translate | markdownLink"
          class="consents__info"
        ></span>
      } @else {
        @for (
          group of getGroupedCountryConsentBySharedCheckbox(consent);
          track group.sharedCheckboxId
        ) {
          <div class="consents__row">
            @let firstPurpose = group.consentPurposes[0];
            @let firstFormControl = form().controls[firstPurpose.purposeId];

            @if (
              firstPurpose.allowApproval &&
              firstFormControl &&
              firstFormControl.enabled
            ) {
              <app-rc-checkbox
                [formControl]="firstFormControl"
                [multiLine]="true"
                class="checkbox-consent"
              >
                @for (
                  purpose of group.consentPurposes;
                  track purpose.purposeId;
                  let index = $index
                ) {
                  <app-detail-terms
                    [consentPurpose]="purpose"
                    [selectedCountry]="countryCodeFormControl().value"
                    class="consents__row__item"
                  ></app-detail-terms>
                }
              </app-rc-checkbox>
            } @else {
              <app-detail-terms
                [consentPurpose]="firstPurpose"
                [selectedCountry]="countryCodeFormControl().value"
                class="consents__row__item"
              ></app-detail-terms>
            }
          </div>
        }
      }
    }
    @if (hasAnyRequiredConsent()) {
      <p class="mandatory-indication-section" aria-hidden="true">
        <span class="required head-margin" aria-hidden="true">*</span
        >{{ 'mandatory_indication' | translate }}
      </p>
    }
  </div>
</ng-container>
